export type UserPromotionStatus = "claimed" | "unclaimed";

export type UserPromotion = {
  id: string;
  sentAt: string;
  promoId: string;
  promoName: string;
  description: string;
  promoTypes: string[];
  potentialBonuses: string[];
  status: UserPromotionStatus;
  claimedAt: string | null;
  claimedAmount: number | null;
  moneyType: string | null;
};

export type ReferredUserSummary = {
  id: string;
  ipAddress: string;
  referralCode: string;
  username: string;
  email: string;
  deposit: number | null;
  depositDate: string | null;
  totalPurchases: number;
  totalBets: number;
  totalPrizeRedemptions: number;
  kyc: string;
  status: "active" | "inactive";
  registrationScore: number;
  invitationDate: string | null;
};

export type UserPromotionsKpis = {
  received: number;
  claimed: number;
  sportsbookFreeCashClaimed: number;
  casinoCashClaimed: number;
};

export type UserReferralsKpis = {
  totalReferred: number;
  purchasingUsers: number;
  lifetimeValue: number;
};

export const EMPTY_USER_PROMOTIONS_KPIS: UserPromotionsKpis = {
  received: 0,
  claimed: 0,
  sportsbookFreeCashClaimed: 0,
  casinoCashClaimed: 0,
};

export const EMPTY_USER_REFERRALS_KPIS: UserReferralsKpis = {
  totalReferred: 0,
  purchasingUsers: 0,
  lifetimeValue: 0,
};
